import React from 'react';

// The Contact pill's envelope. A bare 18x18 gradient glyph (no tile), exactly as
// Figma drew it. Gradient ids are per-instance (useId) so multiple copies on a
// page don't share ids and break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7852F8" />
    <stop offset="1" stopColor="#84AEF6" />
  </>
);

const ContactMailIcon = ({ size = 18 }) => {
  const uid = React.useId();
  const g = (n) => `contact_mail_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14.25 3.75H3.75C2.92157 3.75 2.25 4.42157 2.25 5.25V12.75C2.25 13.5784 2.92157 14.25 3.75 14.25H14.25C15.0784 14.25 15.75 13.5784 15.75 12.75V5.25C15.75 4.42157 15.0784 3.75 14.25 3.75Z"
        stroke={`url(#${g(0)})`}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.625 5.25L9 9.75L15.375 5.25"
        stroke={`url(#${g(1)})`}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={g(0)}
          x1="-1.125"
          y1="6.375"
          x2="9.05192"
          y2="19.4596"
          gradientUnits="userSpaceOnUse"
        >
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient
          id={g(1)}
          x1="-0.5625"
          y1="6.375"
          x2="2.26212"
          y2="14.3781"
          gradientUnits="userSpaceOnUse"
        >
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ContactMailIcon;
